var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" }
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "before-close": _vm.handleClose,
            title: "Edit Profile",
            width: "94%"
          },
          on: { open: _vm.modalOpened }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-6" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Username" } },
                  [
                    _c("el-input", {
                      attrs: {
                        value: _vm.user && _vm.user.username,
                        disabled: ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-6" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Email", prop: "email" } },
                  [
                    _c("el-input", {
                      attrs: { value: _vm.user && _vm.user.email, disabled: "" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-4" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Old password", prop: "old_password" } },
                  [
                    _c("el-input", {
                      attrs: { type: "password" },
                      model: {
                        value: _vm.form.old_password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "old_password", $$v)
                        },
                        expression: "form.old_password"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-4" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "New password", prop: "new_password" } },
                  [
                    _c("el-input", {
                      attrs: { type: "password" },
                      model: {
                        value: _vm.form.new_password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "new_password", $$v)
                        },
                        expression: "form.new_password"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-4" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "New password confirmation",
                      prop: "new_password_confirmation"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "password" },
                      model: {
                        value: _vm.form.new_password_confirmation,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "new_password_confirmation", $$v)
                        },
                        expression: "form.new_password_confirmation"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("Cancel")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }